import z from "zod"
import { EntityProposals } from "./ProposedEntity"

// server returns GUID for each ProposedPrompt
export const ZReturnedPrompt = z.object({
	Title: z.string(),
	// DataType: PromptDataType
	GUID: z.string(),
})
export type ReturnedPrompt = z.infer<typeof ZReturnedPrompt>

// server returns GUID for each ProposedResponse
export const ZReturnedResponse = z.object({
	Title: z.string(),
	GUID: z.string(),
})
export type ReturnedResponse = z.infer<typeof ZReturnedResponse>

export const ZReturnedEntities = z.object({
	prompts: z.array(ZReturnedPrompt),
	responses: z.array(ZReturnedResponse),
})
export type ReturnedEntities = z.infer<typeof ZReturnedEntities>

const ZReturnedPromptsByStateKey = z.record(z.string(), ZReturnedPrompt)
const ZReturnedResponsesByStateKey = z.record(z.string(), ZReturnedResponse)
export const ZReturnedEntityState = z.object({
	prompt: ZReturnedPromptsByStateKey,
	response: ZReturnedResponsesByStateKey,
})
export type ReturnedEntityState = z.infer<typeof ZReturnedEntityState>

export interface ApiBranchProposedEntitiesResponse {
	ReturnedEntities: {
		Prompts: {
			GUID: string,
			Title: string,
		}[],
		Responses: {
			GUID: string,
			Title: string,
		}[],
	}
}

export const createReturnedEntityState = (proposals: EntityProposals, response: ApiBranchProposedEntitiesResponse): ReturnedEntityState => {
	const proposedEntities = proposals.dbProposedEntitiesPayload().ProposedEntities
	const returnedEntities = response.ReturnedEntities
	const state: ReturnedEntityState = {
		prompt: {},
		response: {},
	}
	for(let idx in proposedEntities.Prompts) {
		const proposed = proposedEntities.Prompts[idx]
		const returned = returnedEntities.Prompts[idx]
		state.prompt[proposed.StateKey] = returned
	}
	for(let idx in proposedEntities.Responses) {
		const proposed = proposedEntities.Responses[idx]
		const returned = returnedEntities.Responses[idx]
		state.response[proposed.StateKey] = returned
	}
	return state
}	
